<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2022-2023 (original work) Open Assessment Technologies SA ;

    import { humanizeDurationVisual } from '@oat-sa-private/ui-core';

    /**
     * Component renders a duration
     * @property {number} [value=0] - The duration in ms
     * @property {object} [throttleConfig] - Throttles the display of the duration
     * @property {*} - any rest properties goes as HTML props on the span wrapper
     */
    export let value = 0;
    export let throttleConfig = {
        minutesThreshold: 0
    };

    $: displayedDuration = humanizeDurationVisual(value, throttleConfig);
</script>

<span {...$$restProps}>{displayedDuration}</span>
